import { required, requiredIf } from "vuelidate/lib/validators";
import { updateForm } from "@state/modules";

export const state = {
  form: {
    PrimaryContact_FirstName: null,
    PrimaryContact_LastName: null,
    PrimaryContact_Relationship: null,
    PrimaryContact_Phone: null,
    PrimaryContact_Email: null,
    PC_Address1: null,
    PC_City: null,
    PC_State: "PA",
    PC_ZipCode: null
  },
  formatters: [
    {
      PrimaryName: "formattedName"
    },
    {
      PC_Address: "formattedAddress"
    }
  ]
};

export const validations = {
  form: {
    PrimaryContact_FirstName: {
      required
      /* requiredIf: requiredIf(vueInstance => {
        return vueInstance.isProfessional === "yes";
      }) */
    },
    PrimaryContact_LastName: {
      required
      /* requiredIf: requiredIf(vueInstance => {
        return vueInstance.isProfessional === "yes";
      }) */
    },
    PrimaryContact_Relationship: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.isProfessional === "yes";
      })
    },
    PrimaryContact_Phone: {
      required
      /* requiredIf: requiredIf(vueInstance => {
        return vueInstance.isProfessional === "yes";
      }) */
    }
  }
};

export const getters = {
  formattedName: state => {
    return (
      state.form.PrimaryContact_FirstName +
      " " +
      state.form.PrimaryContact_LastName
    );
  },
  formattedAddress: state => {
    return (
      state.form.PC_Address1 +
      " " +
      state.form.PC_City +
      ", " +
      state.form.PC_State +
      "  " +
      state.form.PC_ZipCode
    );
  }
};

export const mutations = {
  updateForm
};

export const actions = {};
